import { inject, Pipe, PipeTransform } from '@angular/core';

import { ReferentielStore } from '../../administration/gestion-référentiels/store/referentiel.store';

@Pipe({
  name: 'convertIdsReferentielsToNoms',
})
export class ConvertIdsReferentielsToNomsPipe implements PipeTransform {
  readonly #référentielStore = inject(ReferentielStore);

  transform(values: string[]): string {
    return values.map((value) => this.#référentielStore.entityMap()[value]?.nom ?? 'Non trouvé').join(', ');
  }
}
